import {Button} from '/ui/components/button/button';
import {Input} from '/ui/components/input/input';
import {Radio} from '/ui/components/radio/radio';
import {useIsSmallViewport} from '/ui/lib/responsivity';

import * as styles from '/src/com/yext/listingslaunchstorm/js/components/styles/verifyentity.module.scss';

/**
 * @param {{
 *  emailDestination: string,
 *  emailDomain: !string,
 *  useAltEmail: boolean,
 *  setUseAltEmail: function(boolean): void,
 *  setEmailDestination: function(string): void,
 * }} props
 * @return {React.ReactNode}
 */
export const EmailSelection = ({
  emailDestination,
  emailDomain,
  useAltEmail,
  setUseAltEmail,
  setEmailDestination,
}) => {
  return (
    <div className={styles.selectableEmailOptions}>
      <div>
        {yext.msg('Select the email you’d like to send your verification code to. (Please select an email you have access to.)')}
      </div>
      <Radio
        label={emailDestination}
        value="non-alternate"
        name="email-option"
        onChange={() => setUseAltEmail(false)}
        checked={!useAltEmail}
      />
      <Radio
        label={
          <AlternateEmailInput
            useAltEmail={true}
            emailDomain={emailDomain}
            setFinalEmail={setEmailDestination}
          />}
        value="alternate"
        name="email-option"
        onChange={() => setUseAltEmail(true)}
        checked={useAltEmail}
      />
    </div>
  );
};

/**
 * @param {{
 *  useAltEmail: boolean,
 *  emailDomain: !string,
 *  setFinalEmail: function(string): void,
 * }} props
 */
const AlternateEmailInput = ({
  useAltEmail,
  emailDomain,
  setFinalEmail: setEmail,
}) => {
  return (
    <div className={styles.emailVerificationSelection}>
      <div>{yext.msg('Another email')}</div>
      {useAltEmail && <div className={styles.emailVerificationInput}>
        <Input label={yext.msg('Alternate Email Username')}
          hideLabel={true}
          onChange={data => setEmail(data + '@' + emailDomain)}
        />
        <div className={styles.emailDomain}>
          {'@' + emailDomain}
        </div>
      </div>}
    </div>
  );
};

/**
 * @param {{
 *  emailDestination: !string,
 *  usernameEditable: boolean,
 *  requestVerificationFromPublisher: function(string): void,
 *  onDidSend: function(): void,
 *  setEmailDestination: function(string): void,
 * }} props
 */
export const SendCodeToEmailButton = ({
  emailDestination,
  usernameEditable,
  requestVerificationFromPublisher,
  onDidSend,
  setEmailDestination,
}) => {
  const isSmallViewport = useIsSmallViewport();
  return (
    <div>
      {!usernameEditable
       && <p>{yext.msg('A code will be sent to: {0}.', emailDestination)}</p>}
      <Button
        pendoId="listings-launch-flow-verifying-send-code"
        context="primary"
        fullWidth={isSmallViewport}
        onClick={() => {
          requestVerificationFromPublisher(emailDestination);
          onDidSend();
          if (usernameEditable) {
            setEmailDestination(emailDestination);
          }
        }}
      >
        {yext.msg('Send Code')}
      </Button>
    </div>
  );
};
